<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="mainContentFullWith unselectable">
  <div class="unselectable headerTitle headline">Logs</div>
  <div class="breakLine"></div>
  <div id="moduleContent">
    <ejs-grid #damageAdministrationLogsGrid
              id="damageAdministrationLogsGrid"
              [locale]="locale"
              [dataSource]="dataSource"
              (toolbarClick)="toolbarClick($event)">
      <e-columns>
        <e-column field="LogId" headerText="Log Id" width="100px" textAlign="left" isPrimaryKey="true"></e-column>
        <e-column field="LogMessage" headerText="Aktion" textAlign="left"></e-column>
        <e-column field="LoggedByUser" headerText="Benutzer" width="150px" textAlign="left"></e-column>
        <e-column field="DocNum" headerText="Dokumentennummer" width="200px" textAlign="left"></e-column>
        <e-column field="ModifyDate" headerText="Datum" width="150px" textAlign="left"></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>
<app-footer></app-footer>
